'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true,
});
exports.default = getViewportDimensions;
// Extracted for ease of mocking

function getViewportDimensions() {
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
}
